import FerryEdit from '@/controllers/ferry/ferry-edit.js';

export default {
  extends: FerryEdit,
}
